import {
	StoreAsyncItem,
	ActionResponse,
	createReducer,
	createAsyncInitialState,
	checkAsyncAction,
} from '@flux';
import { mainStatusActionsPack } from '../actions';


export type MainStatusState = {
	status: StoreAsyncItem<PartnerStatus>;
};

const initialState: MainStatusState = {
	status: createAsyncInitialState(null),
};

const mainStatusReducer = createReducer(initialState, {
	[mainStatusActionsPack.types.FETCH_STATUS]: (action: ActionResponse<PartnerStatus>, state) => {
		return {
			status: checkAsyncAction(action, state.status),
		};
	},
});

export default mainStatusReducer;
